import InterMediumText from './InterMediumText';

export default InterMediumText;
